module.exports = __webpack_public_path__ + "static/Tax_img2@2x.445f682e.png";